/**
 * UI Store
 * Manages UI component states
 */
import { create } from 'zustand';

interface UIStore {
  rulerToolOpen: boolean;
  sidebarExpanded: boolean;

  // Actions
  setRulerToolOpen: (open: boolean) => void;
  setSidebarExpanded: (expanded: boolean) => void;
}

export const useUIStore = create<UIStore>((set) => ({
  rulerToolOpen: false,
  sidebarExpanded: false,

  setRulerToolOpen: (open) => set({ rulerToolOpen: open }),
  setSidebarExpanded: (expanded) => set({ sidebarExpanded: expanded }),
}));
